import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

export const GlobalSpin: React.FC = () => (
  <div className="flex items-center justify-center min-h-screen">
    <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
  </div>
);

export default GlobalSpin;
